import React, { Component } from "react";
import PropTypes from "prop-types";
import { Image, Button, Icon, Progress, Label, Flag, Dropdown } from "semantic-ui-react";
import Linkify from "linkify-react";
//import ReactMarkdown from 'react-markdown';

import axios from 'axios';
import qs from "qs"; //post to php w/o file_get_contents('php://input');

export default class ChatMesage extends Component {
  //renders a message

  static propTypes = {
    message: PropTypes.object.isRequired,
    contactID: PropTypes.number.isRequired, //current user id
    previousUser: PropTypes.string.isRequired,
    previousTime: PropTypes.number.isRequired,
    darkMode: PropTypes.bool,

    messageClick: PropTypes.func.isRequired,
    messageScroll: PropTypes.func.isRequired,
    messageRef: PropTypes.object.isRequired,
    txt: PropTypes.func.isRequired,

    selectedID: PropTypes.number,
    appState: PropTypes.object.isRequired,
    appStateUpdate: PropTypes.func.isRequired,

  };

  constructor(props) {
    super(props);

    this.devMode = props.appState.devMode;

    this.state = {
        translation: '',
        language: '',
        flag: '',
        updating: false,
    };

   this.axiosConfig = {
       headers: {
           'Accept': 'application/json',
           'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', 
       }
   }
}


translationUpdate = (e) => {

  e.stopPropagation();

  const { props, state } = this;

  if (!props.appState.config.serverURL2)
  {
      console.log('VideoWhisper/components/ChatMessage translationUpdate: missing serverURL2');
      return;
  }

  var data = {}; //POST data

  data['contact_id'] = props.appState.contact_id;
  data['rep'] = props.appState.rep;

  data['ticket_id'] = props.appState.ticket_id;

  data['message'] = props.message;
  data['language'] = props.appState.language;
  data['flag'] = props.appState.flag;

  data['devMode'] = this.devMode;
  
  var self = this;

  axios.post(props.appState.config.serverURL2 + 'translate.php', qs.stringify(data), this.axiosConfig)
      .then(function (response) {
          self.translationReceived(response);
      })
      .catch( (error) => this.translationError(error, data) );

  this.setState({updating: true});
}

translationReceived(response) {
  const { state } = this;
  const data = response.data;

  if (data.translation)
  {
      this.setState({translation: data.translation, language: data.language, flag: data.flag, updating: false});
  }else this.setState({updating: false});
}

translationError(error, data) {
  console.log('VideoWhisper/components/ChatMessage translationError:', error, data);
  this.setState({ updating: false});
}


  render() {
    const { props, state } = this;

    const message = props.message;

    const isOwnMessage = message.contactID === props.contactID;
    const isNotification = message.notification;
    const sameUser =
      props.previousUser == message.contactName + "#" + message.contactID;
    const sameTime = message.time - props.previousTime < 60000; //in ms

    var avatar = message.userAvatar ? (
      <Image src={message.userAvatar} avatar verticalAlign="middle" />
    ) : (
      ""
    );

    //console.log('components/ChatMesage render', message, message.notification, isNotification, sameUser && !isNotification);

    const messageDate = new Date(message.time * 1000);
    const messageDateTime =
      messageDate.toLocaleDateString() +
      " at " +
      messageDate.toLocaleTimeString();

    var className =
      "chatMessage" +
      (props.darkMode ? " dark " : "") +
      (isNotification ? " notification" : " user") +
      (isOwnMessage ? " own" : "") +
      (message.automated ? " automated" : "") + 
      (message.text.length > 100 ? " long" : "");

      var pointing = 'left';
      if (isOwnMessage) pointing = 'right';

    var outputMenu = (<Dropdown icon="ellipsis vertical" className="icon messageMenu" pointing={pointing} button simple compact size="tiny">
        <Dropdown.Menu>
          <Dropdown.Item icon="mouse pointer" text={props.txt("Click")} disabled />
          <Dropdown.Item icon="copy" text={props.txt("Copy")} onClick={(e) => navigator.clipboard.writeText(message.text)} />
          <Dropdown.Item icon="reply" text={props.txt("Reply")} onClick={(e) => props.messageClick(e, message.ID, message.contactName) } />
          {props.appState.config.siteAdmin ||  this.devMode ? ( <Dropdown.Item icon="list" text={props.txt("Info")} onClick={(e) => props.appStateUpdate( {'openMessage': message.ID} ) } />) : ''}
        </Dropdown.Menu>
      </Dropdown>);

    var outputUser =
      sameUser || isNotification ? (
        ""
      ) : (
        <strong>
          {avatar} <Icon name="user" />
          {message.contactName}
        </strong>
      );

    var outputTime =
      sameUser && sameTime ? (
        ""
      ) : (
        <i>
          <Icon name="time" />
          {messageDateTime}
        </i>
      ); //hide time if same user and same time

    var outputHead =
      outputUser || outputTime ? (
        <>
          {outputUser} {outputTime}{outputMenu}<br />
        </>
      ) : (
        {outputMenu}
      );

    var outputImage = "";
    if (message.image)
      outputImage = (
        <Image src={message.image} size="mini" rounded verticalalign="middle" />
      );

    var messageID = "message" + message.ID;

 var multilanguageCode = '';
    if (props.appState.config.multilanguage) multilanguageCode =  ( message.flag ? ( message.flag != props.appState.flag ? ( state.flag == props.appState.flag ? (<div> <Flag name={message.flag}/> <br/> {state.translation.split("\n").map((i,key) => {return <div key={key}>{i}</div>; })} <Flag name={state.flag}/></div>) : ( props.appState.config.translations ? <Button onClick={this.translationUpdate} compact basic size='tiny' disabled={state.updating} loading={state.updating} className={(props.darkMode?'inverted ':'')}><Flag name={message.flag}/> → <Flag name={props.appState.flag}/></Button> : <Flag name={message.flag}/> ) ) : <Flag name={message.flag}/> ): '' );

    return (
      <li
        className={className}
        key={message.ID}
        ref={props.messageRef}
        id={messageID}
        name={messageID}>
        {outputHead}
        {outputImage}

        {message.mentionMessage != 0 && message.mentionMessage != undefined? (
          <span>
            {" "}
            <Button
            data-tooltip={props.txt("Scrool to Message")}
            onClick={(e) => props.messageScroll(e, message.mentionMessage)}
            size="tiny"
            className={props.darkMode ? "inverted " : ""}
            target="_blank"
            basic
            compact
            icon>
            <Icon name="reply" />
          </Button>
          <Label compact size="tiny">{message.mentionUser}</Label>
            <Label basic compact size="tiny">{message.mentionMessageText}...</Label>
            <br/>
          </span>
        ) : (
          ""
        )}

        {props.selectedID == message.ID ? (
          <span>
            <Icon name="arrow right" />
          </span>
        ) : (
          ""
        )}
        {props.selectedID == -1 ? (
          <span>
            <Icon name="caret right" />
          </span>
        ) : (
          ""
        )}

        <label
          style={message.progressTotal ? { minWidth: "45%" } : {}}
          id={"m" + message.ID}
          //onClick={ (e) =>props.messageClick(e, message.ID, message.contactName)}
          >
               {message.video ? (
          <div>
            <video
              style={{ maxWidth: "100%" }}
              src={message.video}
              controls></video>
          </div>
        ) : (
          ""
        )}
        
        {message.audio ? (
          <div>
            <audio src={message.audio} controls></audio>
          </div>
        ) : (
          ""
        )}

    {message.picture ? (
          <div>
            <img src={message.picture} verticalAlign="middle" style={{ maxWidth: "100%", maxHeight: "320px" }}></img>
          </div>
        ) : (
          ""
        )}

  {message.files ?
   message.files.map( (file) => {

    var output = [];

    if (file.video) output.push(<video key={file.file_name} src={file.picture} controls style={{ maxWidth: "100%", maxHeight: "320px" }}></video>);
    if (file.audio) output.push(<audio key={file.file_name} src={file.picture} controls style={{ maxWidth: "100%", maxHeight: "320px" }}></audio>);
    if (file.picture) output.push(<img key={file.file_name} src={file.picture} verticalAlign="middle" style={{ maxWidth: "100%", maxHeight: "320px" }}></img>);
    output.push(<div key={'b'+file.file_name}><Button
      className={props.darkMode ? "inverted " : ""}
      target="_blank"
      href={file.file_url}
      compact size="tiny"
      >
      <Icon name="file" />
      {file.file_name}
    </Button></div>)
    return output; 
  } )
  : (
          ""
        )}
          {message.text.split("\n").map((i, key) => {
            return (
              <div key={key} className="chatParagraph">
                <Linkify options={{ target: "_blank" }}>{i}</Linkify>
              </div>
            );
          })}
          {message.progressTotal ? (
            <div>
              <Progress
                style={{ minWidth: "40%" }}
                className={props.darkMode ? "inverted " : ""}
                value={message.progressValue}
                total={message.progressTotal}
                indicating
                progress="ratio"
                size="small">
                {message.progressDetails}
              </Progress>
            </div>
          ) : (
            ""
          )}
          {message.url ? (
            <Button
              className={props.darkMode ? "inverted " : ""}
              target="_blank"
              href={message.url}
              compact
              icon>
              <Icon name="linkify" />
            </Button>
          ) : (
            ""
          )}
          {message.count ? (
            <Label>
              <Icon name="mail" /> {message.count}
            </Label>
          ) : (
            ""
          )}
          {message.attachmentsCount ? (
            <Label>
              <Icon name="file" /> {message.attachmentsCount}
            </Label>
          ) : (
            ""
          )}
          {message.recordingsCount ? (
            <Label>
              <Icon name="file video" /> {message.recordingsCount}
            </Label>
          ) : (
            ""
          )}
          {message.file_name ? (
            <span>
              {" "}
              {message.file_name} {message.file_size}{" "}
              <Button
                className={props.darkMode ? "inverted " : ""}
                target="_blank"
                href={message.file_url}
                compact
                icon>
                <Icon name="download" />
              </Button>{" "}
            </span>
          ) : (
            ""
          )}
            {multilanguageCode}
        </label>
      </li>
    );
  }
}
